import { render, staticRenderFns } from "./back-link.vue?vue&type=template&id=770e3ba3&scoped=true"
import script from "./back-link.vue?vue&type=script&lang=js"
export * from "./back-link.vue?vue&type=script&lang=js"
import style0 from "./back-link.vue?vue&type=style&index=0&id=770e3ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e3ba3",
  null
  
)

export default component.exports